import axios from "axios";
import { useCallback, useEffect, useState } from "react";

const useCrudOperation = (tableName) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusQuote, setStatus] = useState({
    message: null,
    isError: null,
  });
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      // const response = await axios.post(`/cm/close_loop/${tableName}`);
      // const response = await axios.get(`http://localhost:3010/${tableName}`);
      const body =
        tableName === "fetch-carmaker_model_record_V2"
          ? { listing: "master" }
          : {};
      const response = await axios.post(`/cm/close_loop/${tableName}`, body);
      setData(response.data);
    } catch (error) {
      if (error && error.response.data.message)
        setStatus({
          message: error.response.data.message,
          isError: true,
        });
      else setStatus({ message: "Error occured", isError: true });
    } finally {
      setLoading(false);
    }
  }, [tableName]);

  const createItem = useCallback(
    async (newItem) => {
      setLoading(true);
      setStatus({
        message: null,
        isError: null,
      });
      try {
        const response = await axios.post(
          `/criteria_master/${tableName}`,
          newItem
        );
        setStatus({
          message: response.data.message,
          isError: false,
        });
        // const response = await axios.post(`http://localhost:3010/${tableName}`, newItem);
        // setData([...data, response.data]);
        fetchData();
      } catch (error) {
        if (error && error.response.data.message)
          setStatus({
            message: error.response.data.message,
            isError: true,
          });
        else setStatus({ message: "Error occured", isError: true });
      } finally {
        setLoading(false);
      }
    },
    [tableName, data]
  );

  const deleteItem = useCallback(
    async (_id) => {
      console.log("Inside delete Item", _id);
      setLoading(true);
      setStatus({
        message: null,
        isError: null,
      });
      try {
        const response = await axios.delete(`/criteria_master/${tableName}`, {
          params: { _id },
        });
        setStatus({
          message: response.data.message,
          isError: false,
        });
        // await axios.delete(`http://localhost:3010/${tableName}/${id}`);
        fetchData();
      } catch (error) {
        if (error && error.response.data.message)
          setStatus({
            message: error.response.data.message,
            isError: true,
          });
        else setStatus({ message: "Error occured", isError: true });
      } finally {
        setLoading(false);
      }
    },
    [tableName]
  );

  const updateItem = useCallback(
    async (_id, updatedItemData) => {
      console.log("INSIDE UPDATE ITEM", _id, updatedItemData);
      updatedItemData.forEach((value, key) => {
        console.log(
          key,
          "=======================================================>",
          value
        );
      });
      setLoading(true);
      setStatus({
        message: null,
        isError: null,
      });
      try {
        const requestData = { ...updatedItemData, _id };
        console.log("BEFORE UPDATE REQUEST DATA", requestData);
        const response = await axios.put(
          `/criteria_master/${tableName}`,
          updatedItemData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        setStatus({
          message: response.data.message,
          isError: false,
        });
        fetchData();
      } catch (error) {
        if (error && error.response.data.message)
          setStatus({
            message: error.response.data.message,
            isError: true,
          });
        else setStatus({ message: "Error occured", isError: true });
      } finally {
        setLoading(false);
      }
    },
    [tableName]
  );

  useEffect(() => {
    fetchData();
  }, [tableName]);

  return {
    data,
    loading,
    statusQuote,
    createItem,
    deleteItem,
    updateItem,
  };
};

export default useCrudOperation;
